export class VQTPOLQADATA {

    ID: number;
    VQT_Timestamp: Date;
    VQuad_Timestamp: Date;

    Call_Timestamp: Date;
    VQuad_Location: string;
    VQuad_PhoneID: string;

    GPS_Position: string;
    GPS_Lat: number;
    GPS_Long: number;

    Deg_File_Name: string;
    Pass_Or_Fail: string;
    POLQA_v3: number;
    POLQA_Score: number;
    EModel_Polqa: number;
    Speech_Level_Diff: number;
    SNR_Diff: number;
    POLQA_ASL_Ref: number;
    POLQA_ASL_Deg: number;
    POLQA_MNL_Ref: number;
    POLQA_MNL_Deg: number;
    POLQA_SNR_Ref: number;
    POLQA_SNR_Deg: number;

    ASR_Ref: number;
    ASR_Deg: number;
    POLQA_OWD: number;
    Delay_Ave: number;
    Delay_Min: number;
    Delay_Max: number;
 
    Number_of_Utterance: number;
    Jitter_Ave: number;
    Jitter_Min: number;
    Jitter_Max: number;

    RSSI: number;
    CallType_Orig: string;
    CallType_Term: string;
    VQuad_CallID: string;
    
    Degraded: string;
    POLQA_SA_Ref: number;
    POLQA_SA_Deg: number;

    constructor() {
     this.ID = 0;
     this.VQT_Timestamp = new Date();
     this.VQuad_Timestamp = new Date();
     
     this.Call_Timestamp = new Date();
     this.VQuad_Location = "";
     this.VQuad_PhoneID = "";
     
     this.GPS_Position = "";
     this.GPS_Lat = 0;
     this.GPS_Long = 0;
   
     this.Deg_File_Name = "";
     this.Pass_Or_Fail = "";
     this.POLQA_v3 = 0;
     this.POLQA_Score = 0;
     this.EModel_Polqa = 0;
     this.Speech_Level_Diff = 0;
     this.SNR_Diff = 0;
     this.POLQA_ASL_Ref = 0;
     this.POLQA_ASL_Deg = 0;
     this.POLQA_MNL_Ref = 0;
     this.POLQA_MNL_Deg = 0;
     this.POLQA_SNR_Ref = 0;
     this.POLQA_SNR_Deg = 0;
    
     this.ASR_Ref = 0;
     this.ASR_Deg = 0;
     this.POLQA_OWD = 0;
     this.Delay_Ave = 0;
     this.Delay_Min = 0;
     this.Delay_Max = 0;
     this.Number_of_Utterance = 0;
     this.Jitter_Ave = 0;
     this.Jitter_Min = 0;
     this.Jitter_Max = 0;
    
     this.RSSI = 0;
     this.CallType_Orig = "";
     this.CallType_Term = "";
     this.VQuad_CallID = "";
     
     //this.Degraded = "";
     //this.POLQA_SA_Ref = 0;
     //this.POLQA_SA_Deg = 0;
    }
}
